export default {
  blank: () => import("/usr/src/app/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/usr/src/app/layouts/default.vue").then(m => m.default || m),
  nocontainer: () => import("/usr/src/app/layouts/nocontainer.vue").then(m => m.default || m)
}